import type { Brand } from '@axo/config/@types/Brand.types';
import { ConfigService } from '@axo/config';
import { getSiteOneHost } from '@axo/config/site/multi-tenant/get-site-one-host';
import type { TermsAndConditions } from '@axo/shared/data-access/types/terms_and_conditions';
import { useQuery } from 'react-query';

export async function getTermsAndConditions(brand: Brand) {
  const { env } = ConfigService.get('env');
  const url = new URL(
    'api/cms/terms-and-conditions',
    getSiteOneHost(brand, env),
  );

  return await fetch(url)
    .then((res) => res.json() as Promise<TermsAndConditions[]>)
    .then((data) => ({
      terms: data.map((terms) => ({
        terms,
        version: getTermsVersion(terms, brand),
      })),
    }));
}

export const useTermsAndConditions = (brand: Brand) => {
  return useQuery({
    queryKey: ['terms-and-conditions', brand],
    queryFn: () => getTermsAndConditions(brand),
  });
};

const getTermsVersion = (term: Partial<TermsAndConditions>, brand: Brand) => {
  if (!term._publish_on)
    throw new Error(`No publish date found on term ${term}`);

  const date = new Date(term._publish_on);
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');

  return `${term.tc_type}: ${term.version}.${year}${month}${day}-${brand};`;
};
